export const ColumnChartStyles = {
    "& .highcharts-title": {
        fontWeight: "bold",
    },
    "& .highcharts-data-table th": {
        width: "300px"
    },
    "& .highcharts-data-table td": {
        textAlign: "center"
    }
}